import type { ReactNode } from 'react'
import usePulseCollapse from './usePulseCollapse'
import { PulseCollapseContent, PulseCollapseFrame } from './styled-components'

interface PulseCollapseProps {
  open: boolean
  scrollOnOpen?: boolean
  children: ReactNode
}

const PulseCollapse = ({ open, scrollOnOpen = true, children }: PulseCollapseProps) => {
  const { isPulse, frameRef, rendered, expanded, settled } = usePulseCollapse(open, scrollOnOpen)

  if (!isPulse) return open ? <>{children}</> : null
  if (!rendered) return null

  return (
    <PulseCollapseFrame ref={frameRef} $expanded={expanded} $settled={settled}>
      <PulseCollapseContent $settled={settled}>{children}</PulseCollapseContent>
    </PulseCollapseFrame>
  )
}

export default PulseCollapse
